import { cn } from '@/utils'
import { CARD_KINDS, KIND_LABEL, KIND_WORDS, type CardKind } from './helpFeedbackText'

/** The four kinds as toggle chips (decision 12): one is always on. */
export function KindChips({ value, onChange, disabled }: {
  value: CardKind
  onChange: (kind: CardKind) => void
  disabled?: boolean
}) {
  return (
    <div role="group" aria-label={KIND_LABEL} className="flex flex-wrap gap-1.5">
      {CARD_KINDS.map((kind) => {
        const on = kind === value
        return (
          <button
            key={kind}
            type="button"
            aria-pressed={on}
            disabled={disabled}
            onClick={() => onChange(kind)}
            className={cn(
              'rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors outline-none',
              'focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50',
              on ? 'border-primary text-primary' : 'border-border text-muted-foreground hover:bg-accent',
            )}
          >
            {KIND_WORDS[kind]}
          </button>
        )
      })}
    </div>
  )
}
